import styled from 'styled-components';

export const TopText = styled.p`
  margin-bottom: 2rem;
`;
